import { NextSeo } from 'next-seo';
import { useState } from 'react';

import MessageReceived from '@components/common/MessageReceived/MessageReceived';
import MostPopularCarsSection from '@components/common/MostPopularCarsSection/MostPopularCarsSection';
import QuestionFormContainer from '@components/common/QuestionFormContainer/QuestionFormContainer';
import SectionWithContainer from '@components/common/SectionWithContainer/SectionWithContainer';
import EnquiryTypes from 'constants/EnquiryTypes';

import RecaptchaContextProvider from 'contexts/recaptchaContext';

export default function Contact() {
  const [submitted, setSubmitted] = useState<boolean>(false);

  return (
    <>
      <NextSeo
        title="Contact Us"
        description="Got a question for us? We answer the most popular questions or you can contact us and we’ll be happy to help."
      />
      <RecaptchaContextProvider>
        {submitted ? (
          <MessageReceived />
        ) : (
          <>
            <div className="my-8">
              <h2 className="mb-2 font-light text-center text-dark-blue-100">
                Get in touch
              </h2>
              <h4 className="px-3 font-light text-center">
                Call us on{' '}
                <span className="text-blue-100 font-bold">
                  <a href="tel:1300746757">1300 746 757 </a>
                </span>
                between 9am and 5pm Monday to Friday.{' '}
              </h4>
              <h4 className="px-3 font-light text-center">
                Fill out the form to ask a question, start a conversation or
                just to say hello.
              </h4>
            </div>
            <SectionWithContainer className="border-t-4 border-blue-100 bg-blue-5">
              <div className="flex items-center justify-center max-w-screen-sm mx-auto">
                <QuestionFormContainer
                  className="w-full"
                  enquiryType={EnquiryTypes.GetInTouch}
                  onSubmit={val => setSubmitted(!!val)}
                />
              </div>
            </SectionWithContainer>
          </>
        )}
        <MostPopularCarsSection />
      </RecaptchaContextProvider>
    </>
  );
}
